import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

/** Vuelve a la vista anterior en el historial; si no hay, usa `fallbackPath`. */
export function useMobileNavigateBack(fallbackPath = '/') {
  const navigate = useNavigate()

  return useCallback(() => {
    const idx = (window.history.state as { idx?: number } | null)?.idx
    if (typeof idx === 'number' && idx > 0) {
      navigate(-1)
      return
    }
    navigate(fallbackPath)
  }, [fallbackPath, navigate])
}
